import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Aperture } from "lucide-react";

const links = [
  { id: "portfolio", label: "Portfolio" },
  { id: "services", label: "Prestations" },
  { id: "manifeste", label: "Manifeste" },
  { id: "reservation", label: "Réservation" },
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
  else if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80 }} animate={{ y: 0 }} transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${scrolled ? "bg-[#0D0D0C]/85 backdrop-blur-xl border-b border-[#F4F0EB]/10" : "bg-transparent"}`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <button data-testid="nav-logo" onClick={() => scrollTo("hero")} className="flex items-center gap-2 group">
          <Aperture className="w-5 h-5 text-[#C88D51] transition-transform duration-700 group-hover:rotate-180" />
          <span className="font-serif-d text-lg tracking-tight">Sel <span className="text-[#C88D51]">&amp;</span> Lumière</span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button key={l.id} data-testid={`nav-link-${l.id === "reservation" ? "booking" : l.id === "manifeste" ? "manifesto" : l.id === "services" ? "services" : "portfolio"}`}
              onClick={() => scrollTo(l.id)} className="font-sub text-sm text-[#A39E93] hover:text-[#F4F0EB] transition-colors link-u">
              {l.label}
            </button>
          ))}
          <Link data-testid="nav-link-client" to="/espace-client" className="font-sub text-sm text-[#A39E93] hover:text-[#F4F0EB] transition-colors link-u">Espace Client</Link>
          <Link data-testid="nav-link-admin" to="/admin" className="font-mono-a text-xs uppercase tracking-[0.2em] px-4 py-2 btn-ghost">Espace Pro</Link>
        </nav>

        <button className="md:hidden text-[#F4F0EB]" onClick={() => setOpen(true)} data-testid="nav-mobile-open"><Menu /></button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 bg-[#0D0D0C] z-50 flex flex-col p-8">
            <div className="flex justify-end"><button onClick={() => setOpen(false)} data-testid="nav-mobile-close"><X className="text-[#F4F0EB]" /></button></div>
            <div className="flex flex-col gap-6 mt-16">
              {links.map((l) => (
                <button key={l.id} onClick={() => { scrollTo(l.id); setOpen(false); }} className="font-serif-d text-4xl text-left">{l.label}</button>
              ))}
              <Link to="/espace-client" className="font-serif-d text-4xl">Espace Client</Link>
              <Link to="/admin" className="font-serif-d text-4xl text-[#C88D51]">Espace Pro</Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
